import { render, staticRenderFns } from "./newa.vue?vue&type=template&id=58e82088&scoped=true&"
import script from "./newa.vue?vue&type=script&lang=js&"
export * from "./newa.vue?vue&type=script&lang=js&"
import style0 from "./newa.vue?vue&type=style&index=0&id=58e82088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e82088",
  null
  
)

export default component.exports